import React, { Component} from 'react';
import * as scriptUtils from './utils/scriptUtils';
import './ChatUserInformationModal.css';
import ChatUserFileUpload from './ChatUserFileUpload';
import { BsCardImage } from "react-icons/bs";


class ChatUserInformationProfilePicture extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
      <div>
        <div className="flex justify-center mt-4">
          <div className="text-base font-semibold text-zinc-500 w-10/12">
            PROFILE PICTURE
          </div>
        </div>
        <div className="flex justify-around mt-2">
          <div className="flex flex-col justify-center items-center w-[76px]" onClick={this.props.selectDefaultPFP}>
            <img
              className="w-10 h-10 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
              src={scriptUtils.getProfileImage(this.props.address)}
            />
            <div
              className={
                this.props.chosenType === 'default'
                  ?
                "text-[10px] text-white mt-2"
                  :
                "text-[10px] text-zinc-400 mt-2"
              }
            >
              DEFAULT
            </div>
          </div>
          <div className="flex flex-col justify-center items-center w-[76px]" onClick={this.props.toggleNFTUploadFlow}>
            <div className="nftImagePlaceholder">
              <div>
                {
                  this.props.pfp !== '' && this.props.isNFTPFP === true
                    ?
                  <img src={this.props.pfp} className="nftPFP" />
                    :
                  <BsCardImage className="nftImageUploadIcon" />
                }
              </div>
            </div>
            <div
              className={
                this.props.chosenType === 'nft'
                  ?
                "text-[10px] text-white mt-2"
                  :
                "text-[10px] text-zinc-400 mt-2"
              }
            >
              USE NFT
            </div>
          </div>
          <ChatUserFileUpload
            chosenType={this.props.chosenType}
            setUploadedFile={this.props.setUploadedFile}
          />
        </div>
      </div>
		);
	}
}

export default ChatUserInformationProfilePicture;
